import {css} from 'emotion'
import { Colors, Font, Link } from './..'

export const StockStyle = (ready) => css({
  maxWidth: '1400px',
  margin: '0 auto',
  minHeight: '100vh',

  '@media (min-width: 1024px)':{
    maxWidth: 'calc(10/12 * 100%)',
  },
  '.print-head': {
    textAlign: 'center',
    display: 'none',
    '&-title': {
      textTransform: 'uppercase',
      fontWeight: 'bold',
      margin: '1rem 0 2rem',
      fontSize: '2rem',
    }
  },
  '.stock': {
    '&-filter': {
      position: 'relative',
    },
    '&-zone': {
      ...Link,
      background: 'black',
      display: 'inline-block',
      margin: '0px auto 2rem auto',
      height: 60,
      lineHeight: '60px',
      padding: '0 2rem',
      color: 'white',
      '@media (min-width: 1024px)': {
        margin: '0px auto 6rem auto',
      },
      'svg': {
        fill: 'white',
        verticalAlign: 'middle',
        marginRight: '1rem',
      }
    },
    '&-button': {
      position: 'fixed',
      bottom: '0',
      right: 0,
      width: 60,
      zIndex: 3,
      opacity: ready ? 1 : 0,
      transition: 'opacity 400ms ease 400ms',
      '@media (min-width: 1024px)': {
        width: 80,
      },
      'button': {
        width: 60,
        height: 60,
        padding: 0,
        textAlign: 'center',
        margin: 0,
        '@media (min-width: 1024px)': {
          width: 80,
          height: 80,
        },
        'svg': {
          margin: 0
        },
        '&.btn-edit': {
          'svg': {
            fill: 'white',
          },
        },
      },
      '.tooltip': {
        position: 'absolute',
        top: 'auto',
        bottom: 0,
        right: 60,
        width: 'calc(100vw - 60px)',
        fontSize: '0.9rem',
        fontFamily: Font.base,
        padding: '0 1rem',
        height: 60,
        background: 'rgba(255, 255, 255, 0.5)',
        '@media (min-width: 1024px)': {
          top: '50%',
          right: 80,
          width: 220,
          transform: 'translateY(-50%)',
          height: 80,
        },
        '&-label': {
          maxWidth: 'calc(100% - 30px)',
          flexBasis: 'calc(100% - 30px)',
        },
        'svg': {
          transform: 'rotate(-90deg)',
        }
      },
    },
    '&-table':{
      marginBottom: '4rem',
      overflow: 'auto',
      display: 'flex',
      flexWrap: 'wrap',

      '@media (min-width: 1024px)': {
        display: 'inherit',
        flexWrap: 'inherit',
      },
      '.head': {
        position: 'relative',
        color: Colors.grey,
        fontSize: '0.8rem',
        fontFamily: Font.title,
       
        fontWeight: 'bold',
        textTransform: 'uppercase',
        borderBottom: `1px solid ${Colors.extraLightGrey}`,
        padding: '1rem 0',
        flexWrap: 'nowrap',
        paddingRight: 120,
        '@media (min-width: 1024px)': {
          paddingRight: 0,
          width: '100%',
          flexWrap: 'wrap',
        },
        '&-item': {
          padding: '0 0.5rem',
          flexShrink: 0,
        },
        '.quantity, .price': {
          textAlign: 'right',
        },
        '.quantity': {
          position: 'absolute',
          right: 0,
          top: 0,
          padding: '1rem 0',
          background: 'white',
          textAlign: 'center',
          
          '@media (min-width: 1024px)': {
            position: 'relative',
            padding: 0,
          }
        }
      },
      '.quantity': {
        width: '120px',
        flexShrink: 0,
        '.qty-number': {
          fontSize: '1.2rem',
          fontWeight: 'bold',
          textAlign: 'center',
          width: '100%',
          padding: '0 25px',
          background: Colors.extraLightGrey,
          '&:after': {
            content: '""',
            position: 'absolute',
            top: 0,
            left: -8,
            width: '100%',
            height: '100%',
            background: 'linear-gradient(to right, rgba(0,0,0,0) 0%,rgba(0,0,0,0.5) 25%,rgba(0,0,0,0) 100%)',
            zIndex: -1,
            '@media (min-width: 1024px)':{
              display: 'none'
            },
          },
        },
      },
      '.ref': {
        width: '120px',
        '@media (min-width: 1024px)': {
          width: '100px',
        }
      },
      '.model': {
        width: '120px' ,
        '@media (min-width: 1024px)': {
          width: '80px' 
        }
      },
      '.desc': {
        width: 200,
        '@media (min-width: 1024px)': {
          maxWidth: 'calc(2/5 * 100% - 440px/3)',
          flexBasis: 'calc(2/5 * 100% - 440px/3)',
          width: 'auto'
        }
      },
      '.picture': {
        width: 80,
        '@media (min-width: 1024px)': {
          maxWidth: 'calc(1.5/5 * 100% - 440px/3)',
          flexBasis: 'calc(1.5/5 * 100% - 440px/3)',
          width: 'auto'
        }
      },
      '.material': {
        width: 200,
        '@media (min-width: 1024px)': {
          maxWidth: 'calc(1.5/5 * 100% - 440px/3)',
          flexBasis: 'calc(1.5/5 * 100% - 440px/3)',
          width: 'auto'
        }
      },
      '.price': {
        textAlign: 'right',
        width: '140px',
        
      },
    },
    '&-line': {
      position:  'relative',
      width: '100%',
      alignItems: 'center',
      borderBottom: `1px solid ${Colors.extraLightGrey}`,
      fontSize: '0.9rem',
      fontFamily: Font.base,
      flexWrap: 'nowrap',
      flexShrink: 0,
      paddingRight: 120,
      '@media (min-width: 1024px)': {
        paddingRight: 0,
        flexWrap: 'wrap',
      },
      '.model': {
        fontWeight: 'bold',
      },
      '.picture, .quantity': {
        height: 80,
        lineHeight: '80px',
      },
      '.quantity': {
        background: Colors.extraLightGrey,
        color: Colors.red,
        position: 'absolute',
        top: 0,
        right: 0,
        zIndex: 5,
        '@media (min-width: 1024px)': {
          position: 'relative',
        },
        '&.body-item': {
          padding: 0,
        },
        '&.fixed': {
          position: 'fixed',
        },
      },
      '.body-item': {
        padding: '0 0.5rem',
        flexShrink: 0,
      },
      '&.no-stock': {
        '.quantity': {
          color: 'black',
        }
      }
    },
    '&-search': {
      width: '100%',
      padding: '1rem',
      textAlign: 'center',
      '@media (min-width: 1024px)': {
        position: 'absolute',
        top: 0,
        maxWidth: 360,
      },
      'input': {
        borderBottom: '0px !important',
        margin: 0,
        fontSize: '0.825rem',
        '& + label': {
          textTransform: 'uppercase',
          fontWeight: 800,
          fontSize: '0.825rem',
          color: 'black',
          width: '100%',
          'svg': {
            fill: 'black',
            verticalAlign: 'middle',
          }
        }
      }
    }
  },
  '@media print': {
    '.print-head': {
      display: 'block',
    }
  }
})

export const StockLineStyle = (picture, first, disabled) => css({
  '&.no-stock': {
    opacity: first ? 1 : 0.5,
    display: disabled && !first ? 'none' : 'flex',
  },
  '.picture': {
    background: `url(${picture}) no-repeat left center`,
    backgroundSize: '60%'
  }
})


// WEBPACK FOOTER //
// ./src/styles/containers/stock.js